export default __webpack_public_path__ + "static/media/uiAccept.d9057c43.mp3";